import React from 'react';
import {Sparklines, SparklinesLine,SparklinesReferenceLine} from "react-sparklines";
import get from 'lodash/get';
import Paper from '@material-ui/core/Paper';

export const SparklineField = ({ record = {}, source }) =>
    <Paper elevation={1}>
        <Sparklines data={get(record, source)} svgWidth={400} svgHeight={50} margin={0} >
            <SparklinesLine style={{ strokeWidth: 1, stroke: "black", fill: "none" }}  />
            <SparklinesReferenceLine type="max" value={1} />
            <SparklinesReferenceLine type="median" value={1} />
        </Sparklines>
    </Paper>;
SparklineField.defaultProps = {
    addLabel: true,
};
